import {
    Typography,
} from "@mui/material";

import { IconTrash, IconPlus } from '@tabler/icons-react';
import { PriceSettingsContainer } from '../../../Styles/Maintenance/priceSettingsStyles';

import { Storage, PriceSettingsInterface } from '../../../Models/Maintenance/PriceSettings/PriceSettings';

import AccessibilityHelper from '../../../Utilities/Helpers/AccessibilityHelper';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { PriceSettingsField } from '../../../Utilities/Enums/ParametersEnum';
import { AdminModules } from '../../../Utilities/Enums/AdminModulesEnum';
import { CurrencyEnum } from '../../../Utilities/Enums/CurrencyEnums';

import CustomButton from '../../../CustomViews/Elements/CustomButton';
import CustomIconButton from '../../../CustomViews/Elements/CustomIconButton';
import FormTextField from '../../../CustomViews/Elements/FormTextField';

export default function StoragesSettings(props: PriceSettingsInterface) {
    //Variables
    let { formData, setformData, errorMessages, setopenDelete, settoDeleteItem, setdeleteType, storageTempId, setstorageTempId, storageCount, setstorageCount, priceSettingsTab, selectedPriceSettingsTab } = props;
    let storageProps: any = [];
    let storagePriceProps: any = [];
    let storageDescriptionProps: any = [];
    let currency = priceSettingsTab?.find((item: any) => item.id == selectedPriceSettingsTab)?.currencyCode ?? "RM";
    currency = (currency != CurrencyEnum.MYR ? currency : 'RM');

    if(storageCount > 0) {
        formData?.[PriceSettingsField.STORAGES]?.forEach((storageItem: any, stIndex: any) => {
            storageProps.push({
                name: PriceSettingsField.STORAGE + storageItem?.tempId,
                title: 'Storage (GB)',
                fieldValue: storageItem?.[PriceSettingsField.STORAGE] ?? "",
                hideLabel: true,
                disabled: !AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_EDIT),
                type: 'number',
                // required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.NAME)?.keyName != null,
                errorMessages: errorMessages,
                handleOnChange: (selectedValue: any) => {
                    let _storages: Storage[]  = formData?.[PriceSettingsField.STORAGES] ?? [];

                    _storages[stIndex] = {
                        ..._storages[stIndex],
                        [PriceSettingsField.STORAGE]: selectedValue ?? ""
                    };

                    if(setformData) {
                        setformData((prev: any) => ({ ...prev, [PriceSettingsField.STORAGES]: _storages }));
                    }
                },
            });

            storagePriceProps.push({
                name: PriceSettingsField.STORAGE_PRICE + storageItem?.tempId,
                title: 'Price (' + currency + ')',
                fieldValue: storageItem?.[PriceSettingsField.STORAGE_PRICE] ?? "",
                hideLabel: true,
                disabled: !AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_EDIT),
                type: 'number',
                // required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.NAME)?.keyName != null,
                errorMessages: errorMessages,
                handleOnChange: (selectedValue: any) => {
                    let _storages: Storage[]  = formData?.[PriceSettingsField.STORAGES] ?? [];

                    _storages[stIndex] = {
                        ..._storages[stIndex],
                        [PriceSettingsField.STORAGE_PRICE]: selectedValue ?? ""
                    };

                    if(setformData) {
                        setformData((prev: any) => ({ ...prev, [PriceSettingsField.STORAGES]: _storages }));
                    }
                },
            });

            storageDescriptionProps.push({
                name: PriceSettingsField.STORAGE_DESCRIPTION + storageItem?.tempId,
                title: 'Description',
                fieldValue: storageItem?.[PriceSettingsField.STORAGE_DESCRIPTION] ?? "",
                hideLabel: true,
                disabled: !AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_EDIT),
                type: 'text',
                // required: requiredFields?.find((field: any) => field.keyName == ModuleSettingField.NAME)?.keyName != null,
                errorMessages: errorMessages,
                handleOnChange: (selectedValue: any) => {
                    let _storages: Storage[]  = formData?.[PriceSettingsField.STORAGES] ?? [];

                    _storages[stIndex] = {
                        ..._storages[stIndex],
                        [PriceSettingsField.STORAGE_DESCRIPTION]: selectedValue ?? ""
                    };

                    if(setformData) {
                        setformData((prev: any) => ({ ...prev, [PriceSettingsField.STORAGES]: _storages }));
                    }
                },
            });
        }); 
    }

    //Event Handlers

    //Rendering Functions
    return <PriceSettingsContainer>
        <Typography className="settingItemHeader" color="primaryText">Storage</Typography>
        <Typography className="settingItemFieldHeader">Storage (GB)</Typography>
        <Typography className="settingItemFieldHeader">Price ({currency}) / Monthly</Typography>
        <Typography className="settingItemFieldHeader span2Item">Description</Typography>

        {formData?.[PriceSettingsField.STORAGES]?.map((ut: any, storageIndex: number) => (<>
            <FormTextField {...storageProps[storageIndex]} />
            <FormTextField {...storagePriceProps[storageIndex]} />
            <FormTextField {...storageDescriptionProps[storageIndex]} />
            {AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_DELETE) ? <CustomIconButton toolTipName='Delete'
                icon={<IconTrash color='var(--buttonHoverBGDangerColor)' />}
                onClick={(e: any) => {
                    if(setopenDelete) {
                        setopenDelete(true);
                    }

                    if(settoDeleteItem) {
                        settoDeleteItem({ index: storageIndex, name: null });
                    }

                    if(setdeleteType) {
                        setdeleteType('storage');
                    }
                }} /> : <div />}
        </>))}

        {AccessibilityHelper.hasAccess(AdminModules.PRICE_SETTINGS_CREATE) && <CustomButton
            btnType={ButtonType.CANCEL}
            title='Add Storage'
            startIcon={<IconPlus />}
            // isRoundedCorner={true}
            onClick={(e: any) => {
                let _storages: Storage[]  = formData?.[PriceSettingsField.STORAGES] ?? [];
                let _storageTempId = (storageTempId ?? 0) + 1;

                if(setformData) {
                    setformData((prev: any) => ({
                        ...prev,
                        [PriceSettingsField.STORAGES]: [
                            ..._storages,
                            {
                                ...new Storage(),
                                tempId: _storageTempId,
                            }
                        ]
                    }));
                }

                if(setstorageTempId) {
                    setstorageTempId(_storageTempId);
                }

                if(setstorageCount) {
                    setstorageCount((storageCount ?? 0) + 1);
                }
            }} />}
    </PriceSettingsContainer>
}